import { createContext } from "react"

const FavoritesBPContext = createContext()

export default FavoritesBPContext
